import dayjs, { Dayjs } from 'dayjs';
import { WorkingHoursScheduleType } from './entity';
import { useAvailableSlotsQuery } from './queries';
import { useEffect } from 'react';
import { useAppDispatch } from '@libs/redux/store';
import { setApiError } from '@libs/redux/apiErrorSlice';

export const normalizeDate = (isoDate: Date | Dayjs) => dayjs(isoDate).format('YYYY-MM-DD');

export type WorkingDay = {
  workingSchedule: WorkingHoursScheduleType | undefined;
  targetDate: string | undefined;
};

export const useAvailableSlots = (date: Dayjs | undefined, serviceId: string | undefined) => {
  const dateStr = date?.format('YYYY-MM-DD');
  const dispatch = useAppDispatch();
  const { data, error } = useAvailableSlotsQuery(dateStr, serviceId);

  useEffect(() => {
    if (error) {
      dispatch(setApiError({ message: error.message, source: 'availableSlots' }));
    }
  }, [error, dispatch]);

  return { slots: data?.slots ?? [], reason: data?.reason, error };
};
